import { render, staticRenderFns } from "./DSTable.vue?vue&type=template&id=a45c8120&"
import script from "./DSTable.vue?vue&type=script&lang=js&"
export * from "./DSTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports